var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.skeleton)?_c('v-skeleton-loader',{attrs:{"type":"image"}}):_c('v-img',_vm._g(_vm._b({attrs:{"aspect-ratio":_vm.aspectRatio,"src":_vm.value,"cover":""}},'v-img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }